<template>
  <div>
    <v-chip
      v-if="status === 1"
      color="#F9D97F"
      style="color: #060607; height: 22px; border-radius: 6px"
      ><v-icon style="margin-right: 10px">mdi-truck-delivery</v-icon
      >Отправлен</v-chip
    >
    <v-chip
      v-if="status === 2"
      color="purple lighten-2"
      style="color: #fff; height: 22px; border-radius: 6px"
      ><v-icon style="margin-right: 10px">mdi-store</v-icon> Принят</v-chip
    >
    <v-chip
      v-if="status === 3"
      color="green"
      style="color: #fff; height: 22px; border-radius: 6px"
      ><v-icon style="margin-right: 10px">mdi-account-check</v-icon>
      Получен</v-chip
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "StatusCard",
  components: {},
  props: {
    status: Number,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["regions", "user"]),
  },
  mounted() {},
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.mx-input {
  height: 43px !important;
}
</style>
